import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Geolocation } from 'src/app/core/models/geolocation.model';

@Component({
  selector: 'app-content-meta-info',
  templateUrl: './content-meta-info.component.html',
  styleUrls: ['./content-meta-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentMetaInfoComponent {
  @Input() locations: Geolocation[] = [];
  @Input() entireArea: boolean = false;
}
